import { buildProps, numericProp, truthProp } from '@xzx-design/utils'

import type { ExtractPropTypes, PropType, Ref } from 'vue'
import type { TabTitle } from '../tab-title'

export const tabTitleProps = buildProps({
  id: {
    type: String,
    default: '',
  },
  dot: Boolean,
  type: {
    type: String,
    default: '',
  },
  color: {
    type: String,
    default: '',
  },
  title: {
    type: String,
    default: '',
  },
  name: {
    type: [String, Number],
    default: '',
  },
  currentName: {
    type: [String, Number],
    default: '',
  },
  badge: {
    type: numericProp,
  },
  shrink: Boolean,
  disabled: Boolean,
  controls: {
    type: String,
    default: '',
  },
  scrollable: {
    type: [Boolean, Object] as PropType<boolean | Ref<boolean>>,
    default: false,
  },
  activeColor: {
    type: String,
    default: '',
  },
  inactiveColor: String,
  showZeroBadge: truthProp,
  parent: {
    type: Object as PropType<any>,
    default: () => ({}),
  },
  index: Number,
  currentIndex: Number,
  state: {
    type: Object as PropType<any>,
    default: () => ({}),
  },
  isActive: {
    type: Boolean,
    default: false,
  },
})

export type TabTitleProps = ExtractPropTypes<typeof tabTitleProps>
export type TabTitleInstance = InstanceType<typeof TabTitle>
